import { render, staticRenderFns } from "./Airbus.vue?vue&type=template&id=48fe371f&scoped=true&"
import script from "./Airbus.vue?vue&type=script&lang=js&"
export * from "./Airbus.vue?vue&type=script&lang=js&"
import style0 from "./Airbus.vue?vue&type=style&index=0&id=48fe371f&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe371f",
  null
  
)

export default component.exports